import { apiV1 } from "@/store";

const state = {
  settings: []
};

const actions = {
  getSettings: ({ commit, dispatch }) => {
    apiV1.get(`settings`)
      .then((resp) => {
        commit("setSettings", resp.data);
      })
      .catch((err) => {
        dispatch("snackbar/handleError", err, { root: true });
        throw new Error(err);
      });
  },
  updateSettings: ({ commit, dispatch }, payload) => {
    apiV1.put(`settings/${payload.id}`, payload)
      .then(() => {
        dispatch("handleSuccess", "Move in payment note successfully updated", { root: true });
      })
      .catch((err) => {
        dispatch("handleError", err, { root: true });
        throw new Error(err);
      });
  },
  updateSettingsSpeederent: ({ commit, dispatch }, payload) => {
    apiV1.put(`settings/${payload.id}`, payload)
      .then(() => {
        dispatch("handleSuccess", "Speederent setting successfully updated", { root: true });
      })
      .catch((err) => {
        dispatch("handleError", err, { root: true });
        throw new Error(err);
      });
  }
};

const mutations = {
  setSettings: (state, settings) => {
    state.settings = settings;
  }
};

export default {
  state,
  actions,
  mutations
};
